var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"venture-grid"},_vm._l((_vm.ventures),function(venture){return _c('VentureCard',{key:venture.slug,attrs:{"venture":venture}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }